import { TextField } from "@mui/material";
import 'dayjs/locale/ko';

const datePickerStyle = {
    "&.MuiFormControl-root.MuiTextField-root":{top:"5px",background:"unset"},
    "& .MuiInputLabel-root":{color:"#000",fontSize:"8pt",top:"-5px",left:"-11px",padding:"2px"},
    "& .MuiInputLabel-shrink":{display:"none"},
    "& .MuiOutlinedInput-input":{color:"#000",paddingRight:"0px",fontSize:"9pt",paddingLeft:"7px",border:"unset"},
    "& .MuiSvgIcon-root":{fill:"unset"},
    "& .MuiOutlinedInput-root":{paddingRight:"0px", height:"39px", top:"-3px", minWidth:"110px"},
    "& .MuiIconButton-root":{width:"unset", height:"unset", padding:"0px",left:"-13px"},
    "& .MuiOutlinedInput-notchedOutline legend":{width:"60px"},
    backgroundColor: "#fff"
};

const iconDeleteBtnStyle = {
    "& .MuiSvgIcon-root":{fill:"unset"},
    position: "absolute", margin: "auto", top: "12px", right: "20px" ,
    cursor:"pointer",
    padding:"0px", width:"unset", height:"unset",
};

const iconCalendarBtnStyle = {
};

const CustomDatePicker2 = ({field, ref, name, ...restProps}) => {

    return (
        <TextField 
            id="outlined-basic" 
            {...field}
            {...restProps}
            placeholder='YYYY-MM-DD'
            inputRef={ref}
            name={name}
        />
    );
};

export default CustomDatePicker2;